import {gsap} from "gsap";

export function initTitleAnimation() {
    if (!$('#animated_title').length & !$('#title_animation_end_trigger').length) return;

    const tabletWidth = 1000;
    const mobileWidth = 760;
    const trigger = $('.body');
    const endTrigger = $('#title_animation_end_trigger');
    const title = $('#animated_title');

    const titleWidth = $('#animated_title .title-inner').width();
    const windowWidth = $(window).width();
    let xTranslate = (windowWidth - titleWidth) / 2;
    let yTranslate = 45;
    if ($(window).width() < tabletWidth) {
        yTranslate = 70;
    }

    if ($(window).width() < mobileWidth ) {
        yTranslate = 110;
    }

    gsap.timeline({
        scrollTrigger: {
            trigger: trigger,
            endTrigger: endTrigger,
            start: 'top+=1 top',
            scrub: true,
            ease: "none",
            invalidateOnRefresh: true,
        }
    })
        .to(title, {x: xTranslate, yPercent: yTranslate});
}
